window.uetq = window.uetq || [];
window.uetq.push("consent", "default", {
  ad_storage: "denied",
});

document.addEventListener("DOMContentLoaded", function () {
  let checkPrivacy = setInterval(() => {
    if (Shopify.customerPrivacy) {
      clearInterval(checkPrivacy);
      shopifyConsent = Shopify.customerPrivacy.getTrackingConsent();
     
      if (shopifyConsent == "yes") {
        window.uetq.push("consent", "update", {
          ad_storage: "granted",
        });
      }
      // Execute seu código aqui
    }
  }, 100);
});

